import { PathwayScenarioLight } from '@/types';
import { Link } from 'react-router-dom';
import { useState, useCallback } from 'react';
import {
  Card,
  CardButton,
  CardMenu,
  CardMenuItem,
  Content,
  Heading,
  Inline,
  InlineItem,
  Secondary,
  ConfirmationDialog,
} from '@kinesis/bungle';
import { GHGProtocolIcon } from '@/components/ghg-protocol-icon';
import { pathwayScenarioPath } from '@/links';
import { formatDistanceStrings } from '@/date';
import { noop } from 'lodash/fp';

const Item = (props: ItemProps) => {
  const { scenario, now, onDelete = noop } = props;
  const [deletePrompt, setDeletePrompt] = useState(false);
  const onDeletePrompt = useCallback(() => {
    setDeletePrompt(true);
  }, [setDeletePrompt]);
  const closeDeletePrompt = useCallback(() => {
    setDeletePrompt(false);
  }, [setDeletePrompt]);

  const onDeleteConfirm = useCallback(() => {
    onDelete(scenario.id);
  }, [scenario, onDelete]);

  return (
    <>
      <Content borderRadiusSize='small'>
        <Card>
          <CardButton
            as={Link}
            to={pathwayScenarioPath(scenario.inventory, scenario.id)}
          >
            <Content padding='medium' paddingMode='equal'>
              <Inline space='medium'>
                <InlineItem>
                  <GHGProtocolIcon />
                </InlineItem>
                <InlineItem ellipsify>
                  <Heading as='h3' size='medium'>
                    {scenario.name}
                  </Heading>
                  <Secondary>{`Last updated ${formatDistanceStrings(now, scenario.updatedAt)}`}</Secondary>
                </InlineItem>
              </Inline>
            </Content>
          </CardButton>
          <CardMenu>
            <CardMenuItem variant='danger' onClick={onDeletePrompt}>
              Delete
            </CardMenuItem>
          </CardMenu>
        </Card>
      </Content>
      {deletePrompt && (
        <ConfirmationDialog
          cancelText='Don’t delete'
          confirmText='Delete scenario'
          onCancel={closeDeletePrompt}
          onConfirm={onDeleteConfirm}
          title={`Delete scenario?`}
          variant='danger'
        >
          This scenario will be removed and can not be recovered.
        </ConfirmationDialog>
      )}
    </>
  );
};

export type ItemProps = {
  scenario: PathwayScenarioLight;
  onDelete?: (scenario: number) => void;
  now: string;
};

export { Item };
